import { ImgProps } from "assets/images/types";

export default function ImgWebserieHavaianasMain(props: ImgProps) {
	const { height = 259, width = 518 } = props;
	return (
		<img
			src="/assets/images/cases/webserie-havaianas/webserie-havaianas-card.webp"
			alt="Paulo Vieira na Webserie Havaianas"
			loading="eager"
			width={width}
			height={height}
		/>
	);
}
